import api from "../../../services/api";
import { errorFormater } from "../../../services/errorHandler";

const createNote = (set) => async (data) => {
  try {
    set({ isLoading: true });
    await api.post("/notes/", data);
    set({ isLoading: false });
  } catch (error) {
    set({ isLoading: false });
    throw errorFormater(error.response);
  }
};

export default createNote;
